import { Skeleton } from "@/components/shared/Skeleton";
import { THUMBNAIL } from "@/lib/constants/shared";

export function LibraryItemCardSkeleton() {
  return (
    <div className="app-card overflow-hidden">
      <Skeleton className={`w-full ${THUMBNAIL.projectAspectRatioClass} rounded-none`} />
      <div className="p-3 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    </div>
  );
}
